import { serviceGo } from "@/utils/request";

export interface ShopItem {
  id?: number
  name: string
  url?: string
  type: string // 道具、好感度、属性
  role_id?: number
  attribute_name?: string
  variable_id?: number | null // 属性商品引用的变量（变量统一 08c）；旧商品迁移前为 null
  variable_name?: string
  value: number
  price: number
  purchase_limit?: number // -1: 不限购, >0: 限购数量
  game_id?: number
  created_at?: string
  updated_at?: string
}

// 获取商品列表
export async function getShopItems(gameId: number): Promise<ShopItem[]> {
  const resp = await serviceGo.get('/api_v2/shop/items', {
    params: { game_id: gameId }
  })
  return resp.data.data || []
}

// 获取单个商品
export async function getShopItem(id: number): Promise<ShopItem> {
  const resp = await serviceGo.get(`/api_v2/shop/items/${id}`)
  return resp.data.data
}

// 创建商品
export async function createShopItem(data: ShopItem): Promise<ShopItem> {
  const resp = await serviceGo.post('/api_v2/shop/items', data)
  return resp.data.data
}

// 更新商品
export async function updateShopItem(id: number, data: Partial<ShopItem>): Promise<ShopItem> {
  const resp = await serviceGo.put(`/api_v2/shop/items/${id}`, data)
  return resp.data.data
}

// 删除商品
export async function deleteShopItem(id: number): Promise<void> {
  await serviceGo.delete(`/api_v2/shop/items/${id}`)
}
